module.exports = __webpack_public_path__ + "img/login-sidebar.1d9b7578.png";